import { InvitedStatusBlueIcon } from 'assets';
import * as S from './styled';

const StatusBlockType = () => {
  return (
    <>
      <S.StatusBlock className="blue">
        <InvitedStatusBlueIcon />
        <p>Invited</p>
      </S.StatusBlock>
    </>
  );
};

export default StatusBlockType;
